export default "__VITE_ASSET__Bgh4miY7__"